// What a redeemed code paid, across the top of the screen for four seconds
// (spec 2026-10-09). One banner at a time: a second redeem replaces the first.
import './codeRewardBanner.css';

export const CODE_BANNER_MS = 4_000;

let current: {
  el: HTMLElement;
  timer: ReturnType<typeof setTimeout>;
  onFullscreen: () => void;
} | null = null;

/**
 * Where the banner must live to be SEEN. While the game is fullscreen the
 * browser draws only the fullscreen element and its children, so a banner on
 * `document.body` exists but is invisible (the bug reported 2026-10-13).
 */
function bannerHost(): Element {
  const doc = document as Document & { webkitFullscreenElement?: Element | null };
  return document.fullscreenElement ?? doc.webkitFullscreenElement ?? document.body;
}

function removeCurrent(): void {
  if (!current) return;
  clearTimeout(current.timer);
  document.removeEventListener('fullscreenchange', current.onFullscreen);
  document.removeEventListener('webkitfullscreenchange', current.onFullscreen);
  current.el.remove();
  current = null;
}

export function showCodeRewardBanner(labels: string[]): void {
  removeCurrent();
  const root = document.createElement('div');
  root.className = 'code-banner';
  root.dataset.testid = 'code-banner';
  root.setAttribute('role', 'status');
  const title = document.createElement('div');
  title.className = 'code-banner-title';
  // Every tower or icon in it was already owned: nothing new to list.
  title.textContent = labels.length > 0 ? 'Code redeemed! You got:' : 'Code redeemed!';
  root.append(title);
  if (labels.length > 0) {
    const items = document.createElement('div');
    items.className = 'code-banner-items';
    for (const label of labels) {
      const s = document.createElement('span');
      s.className = 'code-banner-item';
      s.textContent = label;
      items.append(s);
    }
    root.append(items);
  }
  bannerHost().append(root);
  // A four-second banner can straddle a fullscreen toggle: follow it.
  const onFullscreen = () => bannerHost().append(root);
  document.addEventListener('fullscreenchange', onFullscreen);
  document.addEventListener('webkitfullscreenchange', onFullscreen);
  const timer = setTimeout(() => {
    if (current?.el === root) removeCurrent();
    else root.remove();
  }, CODE_BANNER_MS);
  current = { el: root, timer, onFullscreen };
}
